import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';

class NotFound extends Component {
  render() {
    return (
      <div className="tw-max-w-2xl tw-mx-auto tw-px-4 tw-py-20 tw-text-center">
        <Helmet><title>Page Not Found | Primal Marketplace</title></Helmet>
        <div className="tw-text-8xl tw-font-bold tw-mb-2" style={{ color: '#b8860b', opacity: 0.25 }}>404</div>
        <h1 className="tw-text-2xl tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-2 tw-m-0">Page Not Found</h1>
        <p className="tw-text-sm tw-text-[#888] dark:tw-text-[#666] tw-mb-8 tw-m-0">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="tw-flex tw-justify-center tw-gap-3 tw-flex-wrap">
          <Link
            to="/"
            className="tw-inline-block tw-px-5 tw-py-2.5 tw-rounded-lg tw-text-sm tw-font-semibold tw-text-white tw-no-underline tw-transition-colors"
            style={{ backgroundColor: '#b8860b' }}
          >
            Go Home
          </Link>
          <Link
            to="/browse"
            className="tw-inline-block tw-px-5 tw-py-2.5 tw-rounded-lg tw-text-sm tw-font-semibold tw-border tw-no-underline tw-transition-colors tw-text-[#888] dark:tw-text-[#aaa] tw-border-[#e0e0e0] dark:tw-border-[#333] tw-bg-transparent"
          >
            Browse Cards
          </Link>
        </div>
      </div>
    );
  }
}

export default NotFound;
